import { Link } from "react-router-dom";

function GroupItem({
  className,
  children,
  to,
}: {
  className: string;
  children: JSX.Element | JSX.Element[];
  to: string;
}) {
  return (
    <Link to={to} type="button" className={[className, "group"].join(" ")}>
      {children}
    </Link>
  );
}

export default GroupItem;
